import { Auth } from "aws-amplify";

interface ICheckTokenExpiration {
    tryNumber?: number;
    tryAgainError?: {
        tryAgain: boolean;
        tryAgainInSeconds?: number;
    };
}

export const checkTokenExpiration: (
    params: ICheckTokenExpiration
) => Promise<boolean> = async (params?: ICheckTokenExpiration) => {
    const { tryAgainError, tryNumber = 1 } = params || {};
    try {
        const session = await Auth.currentSession();
        const currentTime = Math.floor(new Date().getTime() / 1000);
        const expirationTime = session.getIdToken().getExpiration();

        // console.log("expirationTime", expirationTime);
        // console.log("expirationTime date", new Date(expirationTime * 1000));

        // Token is nearing expiration or has expired
        // return currentTime >= expirationTime - 300; // Adjust the buffer time as needed

        // add 15 seconds to the expiration time to account for any latency
        const newExpirationTime = expirationTime + 15;

        // console.log("expirationTime date", new Date(expirationTime * 1000));
        // console.log(
        //     "newExpirationTime date",
        //     new Date(newExpirationTime * 1000)
        // );

        // return currentTime >= expirationTime; // Adjust the buffer time as needed
        if (currentTime >= newExpirationTime) {
            console.log(
                `Token expirado por tempo. Data de expiração: ${new Date(
                    expirationTime * 1000
                )}. Data atual: ${new Date(currentTime * 1000)}`
            );
            return true;
        } else {
            return false;
        }
    } catch (error) {
        console.log(`Token expirado por erro. Tentativa ${tryNumber}.`, error);
        if (tryAgainError?.tryAgain) {
            // wait for the specified time before trying again
            await new Promise((resolve) =>
                setTimeout(
                    resolve,
                    (tryAgainError?.tryAgainInSeconds || 10) * 1000
                )
            );
            const newResult = await checkTokenExpiration({
                tryNumber: tryNumber + 1
            });
            return newResult;
        } else {
            return true; // Assume the token is invalid if there's an error fetching the session
        }
    }
};
